export function getProximoVencimento(dia: number = 1): string {
  const hoje = new Date();
  const proximoMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, dia);

  const ano = proximoMes.getFullYear();
  const mes = String(proximoMes.getMonth() + 1).padStart(2, "0");
  const diaFormatado = String(proximoMes.getDate()).padStart(2, "0");

  return `${ano}-${mes}-${diaFormatado}`;
}

export function getProximoVencimentoPadrao(): string {
  return getProximoVencimento(1);
}

export function getProximoDia10(): string {
  return getProximoVencimento(10);
}

export function formatarDataBr(isoDate: string): string {
  const [ano, mes, dia] = isoDate.split("-");
  return `${dia}/${mes}/${ano}`;
}
